// extracted by mini-css-extract-plugin
export default {"saveButton":"Footer_saveButton__+2Etz","routerLink":"Footer_routerLink__xB8oz","icon":"Footer_icon__zZ0VR"};